export const sitiosConstants = {
    GETALL_REQUEST_SITIOS: 'GETALL_REQUEST_SITIOS',
    GETALL_SUCCESS_SITIOS: 'GETALL_SUCCESS_SITIOS',
    GETALL_FAILUR_SITIOS: 'GETALL_FAILURE_SITIOS',
};
